import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import { getTopTaalUserQuery } from "@/api/queries/toptaalUsers/useTopTaalUser"
import { FormStyle } from "toptaal-shared"
import TeachingQualificationsForm from "@/pages/onboarding/forms/TeachingQualificationsForm"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useRouter } from "@tanstack/react-router"
import { toptaalUserQueryKeys } from "@/api/query-keys/users"

export const Route = createFileRoute("/profiel/lesbevoegdheid/invullen/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { data } = useCurrentUserSuspenseQuery()
  const router = useRouter()

  const { data: userData } = useSuspenseQuery(
    getTopTaalUserQuery(Number(data.data.userId)),
  )

  const handleNavigateOnSucces = () => {
    router.navigate({ to: "/profiel/lesbevoegdheid", replace: true })
  }

  return (
    <FormStyle className="mx-auto my-8">
      <TeachingQualificationsForm
        user={userData.data}
        type="create"
        formTitle="Lesbevoegdheid"
        handleNavigate={handleNavigateOnSucces}
        queryKeyToReset={toptaalUserQueryKeys.detail(userData.data.userId)}
      />
    </FormStyle>
  )
}
